import React from 'react'

function Profile() {
  return (
    <div className='profile mt-4 c-bg'>
        <img src="https://neal.fun/spend/billgates.jpg" alt='Bill Gates'/>
        <h1>Spend Bill Gates' Money</h1>
    </div>
  )
}

export default Profile